// 电子保函 -> 标段状态更新
import request from "../../request";
let bhNgs = "/baohanNGS";

// 查询标段状态更新列表
export const getSelectSectionList = function(data) {
  return request({
    url: bhNgs + "/selectSectionList",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询标段状态更新信息
export const getSelectSection = function(data) {
  return request({
    url: bhNgs + "/selectSection",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};
